export default __webpack_public_path__ + "static/media/customerAvailability.6efd35d2.svg";